var map = {
	"./be a good smoker1.jpg": [
		1933,
		933
	],
	"./be a good smoker2.jpg": [
		2925,
		925
	],
	"./be a good smoker3.jpg": [
		5076,
		76
	],
	"./be a good smoker4.jpg": [
		8816,
		816
	],
	"./can't talk rn.png": [
		3699,
		699
	],
	"./colourful coral-01.png": [
		8915,
		915
	],
	"./colourful coral-02.png": [
		9872,
		872
	],
	"./mermaid magic-01.png": [
		3588,
		588
	],
	"./mermaid magic-02.png": [
		735,
		735
	],
	"./pink christmas-01.png": [
		1000,
		0
	],
	"./pink christmas-02-02.png": [
		4040,
		40
	],
	"./pink christmas-03.png": [
		4766,
		766
	],
	"./south african classics-01.png": [
		8472,
		472
	],
	"./south african classics-02.png": [
		4229,
		229
	],
	"./south african classics-03.png": [
		6697,
		697
	],
	"./south african classics-04.png": [
		2096,
		96
	],
	"./south african classics-05.png": [
		3848,
		848
	],
	"./under the sea-01.png": [
		8722,
		722
	],
	"./under the sea-02.png": [
		7713,
		713
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3222;
module.exports = webpackAsyncContext;